export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const FORGOT_SUCCESS = 'FORGOT_SUCCESS';
export const FORGOT_FAIL = 'FORGOT_FAIL';
export const FORGOT_LOADER = 'FORGOT_LOADER';
export const USER_LOADED = 'USER_LOADED';
export const USER_LOADED_ADMIN = 'USER_LOADED_ADMIN';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const LOGOUT_ADMIN = 'LOGOUT_ADMIN';
export const GET_PROFILE = 'GET_PROFILE';
export const GET_PROFILES = 'GET_PROFILES';
export const GET_REPOS = 'GET_REPOS';
export const NO_REPOS = 'NO_REPOS';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const CLEAR_PROFILE = 'CLEAR_PROFILE';
export const PROFILE_ERROR = 'PROFILE_ERROR';
export const ACCOUNT_DELETED = 'ACCOUNT_DELETED';
export const GET_POSTS = 'GET_POSTS';
export const GET_POST = 'GET_POST';
export const POST_ERROR = 'POST_ERROR';
export const UPDATE_LIKES = 'UPDATE_LIKES';
export const DELETE_POST = 'DELETE_POST';
export const ADD_POST = 'ADD_POST';
export const ADD_COMMENT = 'ADD_COMMENT';
export const REMOVE_COMMENT = 'REMOVE_COMMENT';
export const AGENT_LISTING_LOADER = 'AGENT_LISTING_LOADER';
export const AGENT_LISTING = 'AGENT_LISTING';
export const SEND_CONNECTION_REQUEST_LOADER = 'SEND_CONNECTION_REQUEST_LOADER';
export const SEND_CONNECTION_REQUEST_DATA = 'SEND_CONNECTION_REQUEST_DATA';
export const REJECT_CONNECTION_REQUEST_LOADER = 'REJECT_CONNECTION_REQUEST_LOADER';
export const REJECT_CONNECTION_REQUEST_DATA = 'REJECT_CONNECTION_REQUEST_DATA';
export const REJECT_CONNECTION_UPDATE_NOTIFICATION_DATA = 'REJECT_CONNECTION_UPDATE_NOTIFICATION_DATA';
export const ACCEPT_CONNECTION_REQUEST_LOADER = 'ACCEPT_CONNECTION_REQUEST_LOADER';
export const ACCEPT_CONNECTION_REQUEST_DATA = 'ACCEPT_CONNECTION_REQUEST_DATA';
export const REMOVE_FRIEND_CONNECTION_REQUEST_LOADER = 'REMOVE_FRIEND_CONNECTION_REQUEST_LOADER';
export const REMOVE_FRIEND_CONNECTION_REQUEST_DATA = 'REMOVE_FRIEND_CONNECTION_REQUEST_DATA';
export const GET_AGENTS_LOADING = 'GET_AGENTS_LOADING';
export const GET_AGENTS = 'GET_AGENTS';
export const REMOVE_AGENTS = 'REMOVE_AGENTS';
export const CONNECTION_LISTING_LOADER = 'CONNECTION_LISTING_LOADER';
export const CONNECTION_LISTING = 'CONNECTION_LISTING';
export const CHANGE_LOADER = 'CHANGE_LOADER';
export const RESET_LOADER = 'RESET_LOADER';
export const CHANGE_SUCCESS = 'CHANGE_SUCCESS';
export const RESET_SUCCESS = 'RESET_SUCCESS';
export const GET_AGENTS_BY_ROLE = 'GET_AGENTS_BY_ROLE';

// scenario for Main Navbar
export const HOME = 'HOME';
export const PAGE_TITLE = 'PAGE_TITLE';
export const AGENTS = 'AGENTS';
export const PROPERTIES = 'PROPERTIES';
export const ABOUT_US = 'ABOUT_US';
export const CONTACT_US = 'CONTACT_US';
export const REGISTER = 'REGISTER';
export const USER_PROFILE = 'USER_PROFILE';
export const FRIENDS = 'FRIENDS';
export const ADD_PROPERTIES = 'ADD_PROPERTIES';
export const MY_PROPERTY = 'MY_PROPERTY';
export const FAVOURITE = 'FAVOURITE';
export const INVITE = 'INVITE';
export const PERMISSION = 'PERMISSION';
export const CHAT = 'CHAT';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const ADMIN = 'ADMIN';




// ADD UPDATE PROFILE
export const ADD_UPDATE_PROFILE_LOADER = 'ADD_UPDATE_PROFILE_LOADER';
export const ADD_UPDATE_PROFILE_DATA = 'ADD_UPDATE_PROFILE_DATA';
export const GET_PROFILE_DATA_LOADER = 'GET_PROFILE_DATA_LOADER';
export const GET_PROFILE_DATA = 'GET_PROFILE_DATA';
export const ADD_UPDATE_USER_PROFILE_PIC_LOADER = 'ADD_UPDATE_USER_PROFILE_PIC_LOADER';
export const ADD_UPDATE_USER_PROFILE_PIC = 'ADD_UPDATE_USER_PROFILE_PIC';
export const ADD_UPDATE_COMPANY_LOG = 'ADD_UPDATE_COMPANY_LOG';


//Agent
export const CHANGE_AGENT_DATA_IN_SEND_CONNECTION_REDUX = 'CHANGE_AGENT_DATA_IN_SEND_CONNECTION_REDUX';

//Property
export const GET_PROPERTY_CATEGORY_LOADER = 'GET_PROPERTY_CATEGORY_LOADER';
export const GET_PROPERTY_CATEGORY = 'GET_PROPERTY_CATEGORY';
export const GET_PROPERTY_SUB_CATEGORY_LOADER = 'GET_PROPERTY_SUB_CATEGORY_LOADER';
export const GET_PROPERTY_SUB_CATEGORY = 'GET_PROPERTY_SUB_CATEGORY';

//Get Country
export const GET_COUNTRIES_LOADER = 'GET_COUNTRIES_LOADER';
export const GET_COUNTRIES = 'GET_COUNTRIES';

//Get States
export const GET_STATES_LOADER = 'GET_STATES_LOADER';
export const GET_STATES = 'GET_STATES';

//Get Cities
export const GET_CITIES_LOADER = 'GET_CITIES_LOADER';
export const GET_CITIES = 'GET_CITIES';


// Get UnitOfMeasures
export const GET_UNIT_OF_MEASURES_LOADER = 'GET_UNIT_OF_MEASURES_LOADER';
export const GET_UNIT_OF_MEASURES = 'GET_UNIT_OF_MEASURES';

// Get Amenities
export const GET_AMENITIES_LOADER = 'GET_AMENITIES_LOADER';
export const GET_AMENITIES = 'GET_AMENITIES';

// Add Property
export const ADD_PROPERTY_LOADER = 'ADD_PROPERTY_LOADER';
export const ADD_PROPERTY = 'ADD_PROPERTY';
export const UPLOAD_PROPERTY_IMAGE_LOADER = 'UPLOAD_PROPERTY_IMAGE_LOADER';
export const UPLOAD_PROPERTY_IMAGE = 'UPLOAD_PROPERTY_IMAGE';
export const GET_PROPERTY_DETAILS_LOADER = 'GET_PROPERTY_DETAILS_LOADER';
export const GET_PROPERTY_DETAILS = 'GET_PROPERTY_DETAILS';

export const UPDATE_PROPERTY_LOADER = 'UPDATE_PROPERTY_LOADER';
export const UPDATE_PROPERTY = 'UPDATE_PROPERTY';

export const GET_ALL_PROPERTIES_LIST_LOADER = 'GET_ALL_PROPERTIES_LIST_LOADER';
export const GET_ALL_PROPERTIES_LIST = 'GET_ALL_PROPERTIES_LIST';
export const GET_PROPERTIES_COUNT = 'GET_PROPERTIES_COUNT';
export const REMOVE_PROPERTIES = 'REMOVE_PROPERTIES';


export const GROUP_CONVERSATION_LISTING_LOADER = 'GROUP_CONVERSATION_LISTING_LOADER';
export const GROUP_CONVERSATION_LISTING = 'GROUP_CONVERSATION_LISTING';
export const FIRTS_TIME_GROUP_CONVERSATION_LISTING = 'FIRTS_TIME_GROUP_CONVERSATION_LISTING';
export const REMOVE_GROUP_CONVERSATION_LISTING = 'REMOVE_GROUP_CONVERSATION_LISTING';
export const NEXT_GROUP_CONVERSATION_API_CALL = 'NEXT_GROUP_CONVERSATION_API_CALL';

export const SET_CHAT_DATA_REDUX = 'SET_CHAT_DATA_REDUX';
export const APPEND_CHAT_MESSAGE = 'APPEND_CHAT_MESSAGE';
export const APPEND_RECEIVER_CHAT_MESSAGE = 'APPEND_RECEIVER_CHAT_MESSAGE';
export const APPEND_LAST_CHAT_MESSAGE = 'APPEND_LAST_CHAT_MESSAGE';
export const APPEND_CHAT_MESSAGE_GROUP = 'APPEND_CHAT_MESSAGE_GROUP';
export const GROUP_MESSAGE = 'GROUP_MESSAGE';
export const SET_ONLINE_DATA_REDUX = 'SET_ONLINE_DATA_REDUX';


export const CREATE_GROUP_LOADER = 'CREATE_GROUP_LOADER';
export const CREATE_GROUP_LISTING = 'CREATE_GROUP_LISTING';

export const GROUP_LISTING_LOADER = 'GROUP_LISTING_LOADER';
export const GROUP_LISTING = 'GROUP_LISTING';


export const GET_SINGLE_USER_LOADER = 'GET_SINGLE_USER_LOADER';
export const GET_SINGLE_USER = 'GET_SINGLE_USER';

export const UPDATE_SINGLE_USER_LOADER = 'UPDATE_SINGLE_USER_LOADER';
export const UPDATE_SINGLE_USER = 'UPDATE_SINGLE_USER';

export const DELETE_SINGLE_USER_LOADER = 'DELETE_SINGLE_USER_LOADER';
export const DELETE_SINGLE_USER = 'DELETE_SINGLE_USER';

export const UPDATE_GROUP_LOADER = 'UPDATE_GROUP_LOADER';
export const UPDATE_GROUP_LISTING = 'UPDATE_GROUP_LISTING';
export const SET_TOTAL_CONVERSATION_COUNT = 'SET_TOTAL_CONVERSATION_COUNT';
export const UPDATE_GROUP_LISTING_BACKEND = 'UPDATE_GROUP_LISTING_BACKEND';

export const DELETE_GROUP_LOADER = 'DELETE_GROUP_LOADER';
export const DELETE_GROUP_LISTING = 'DELETE_GROUP_LISTING';

export const EXIT_GROUP_LISTING_LOADER = 'EXIT_GROUP_LISTING_LOADER';
export const EXIT_GROUP_LISTING = 'EXIT_GROUP_LISTING';

export const LIKE_PROPERTY_LOADER = 'LIKE_PROPERTY_LOADER';
export const LIKE_PROPERTY_DATA = 'LIKE_PROPERTY_DATA';

export const UNLIKE_PROPERTY_LOADER = 'UNLIKE_PROPERTY_LOADER';
export const UNLIKE_PROPERTY_DATA = 'UNLIKE_PROPERTY_DATA';


export const GET_SUGGESTED_LOCATION_LOADER = 'GET_SUGGESTED_LOCATION_LOADER';
export const GET_SUGGESTED_LOCATIONS = 'GET_SUGGESTED_LOCATIONS';



//GET PERMISSION
export const GET_PERMISSION_LOADER = 'GET_PERMISSION_LOADER';
export const GET_PERMISSIONS = 'GET_PERMISSIONS';

//GET ROLE
export const GET_ROLE_LOADER = 'GET_ROLE_LOADER';
export const GET_ROLE = 'GET_ROLE';
export const GET_SINGLE_ROLE_DETAILS = 'GET_SINGLE_ROLE_DETAILS';
export const ADD_UPDATE_ROLE = 'ADD_UPDATE_ROLE';


//  Connect to Global India RealEstate
export const CONNECT_TO_GIRE_LOADER = 'CONNECT_TO_GIRE_LOADER';
export const CONNECT_TO_GIRE_SUCCESS = 'CONNECT_TO_GIRE_SUCCESS';
export const ADD_PROPERTY_TO_GIRE_LOADER = 'ADD_PROPERTY_TO_GIRE_LOADER';
export const ADD_PROPERTY_TO_GIRE = 'ADD_PROPERTY_TO_GIRE';

//Make Notification read
export const ADD_READ_NOTIFICATION_LOADER = 'ADD_READ_NOTIFICATION_LOADER';
export const ADD_READ_NOTIFICATION = 'ADD_READ_NOTIFICATION';
export const LOGIN_SUCCESS_ADMIN = 'LOGIN_SUCCESS_ADMIN';
export const LOGIN_FAIL_ADMIN = 'LOGIN_FAIL_ADMIN';
